import ReactComponent from '../app/ReactComponent'
import {Button, Col, Form, Input, Result, Row, Space, Spin} from 'antd'
import {Link} from 'react-router-dom'
import React, {createRef} from 'react'
import {LeftOutlined} from '@ant-design/icons'
import {isEmail} from '../helpers/utils'
import {$app} from '../app'
import FloatLabel from '../components/inputs/FloatLabel'

export default class PasswordRecoveryPage extends ReactComponent {
  formRef = createRef()
  state = {
    loading_form: false,
    complete: false,
    input_email_value: ''
  }

  componentDidMount() {

    this.pushPageAnalytics('Zapomenuté heslo - Lobsterka')

  }

  async handleLostPasswordForm(data) {

    void this.updateState({loading_form: true})

    try {

      const email = this.state.input_email_value

      if(email === undefined) throw $app.$e('Vyplňte prosím e-mail.')
      if(!isEmail(email)) throw $app.$e('Neplatný e-mail.')

      await this.$api({
        action: 'carecloud_api',
        route: 'send-password-setup-email',
        method: 'POST',
        data: {
          email: email
        }
      })

      void this.updateState({
        complete: true,
        input_email_value: ""
      })

      //this.formRef.current.resetFields()

    } catch (error) {

      $app.$e('E-mail nenalezen.')
      console.error(error)

    } finally {

      void this.updateState({loading_form: false})

    }

  }

  render() {
    return (
      <>
        <Space style={{marginTop: 20}} size={[18, 20]} direction="vertical" className="ml-2">
          <Link to="/">
            <Button type="text" className="btn-cancel" icon={<LeftOutlined style={{marginTop: '2px'}}/>}>Zpět na přihlášení</Button>
          </Link>
        </Space>
        <section className="container full-height centered lost-password">

          <br/>

          <Row align="center" justify="center" gutter={[20, 20]}>
            <Col span={24}>
              <Spin spinning={this.state.loading_form} size={'large'} fullscreen/>


                <h1 className="h3 card-title">Zapomenuté heslo</h1>
                <p className="card-text">Po zadání e-mailu Vám přijde e-mail <br/> s odkazem na obnovení hesla do aplikace.</p>

                {this.state.complete &&
                  <Result

                    status="success"
                    title="Odesláno"
                    subTitle="Na e-mail vám byl zaslán odkaz na obnovení hesla."
                    extra={
                      <Link to="/">
                        <Button type="primary" >Zpět na přihlášení</Button>
                      </Link>
                    }/>
                }

                {!this.state.complete &&
                  <Form
                    ref={this.formRef}
                    layout="vertical"
                    className="mt-4"
                    onFinish={(...args) => this.handleLostPasswordForm(...args)}>

                    <Form.Item rules={[{
                      required: true, message: 'Vyplňte prosím e-mail.'
                    }]}>
                      <FloatLabel label="E-mailová adresa" value={this.state.input_email_value}>
                        <Input
                          size="large"
                          variant="underlined"
                          value={this.state.input_email_value} onChange={(e) => {
                          void this.updateState({input_email_value: e.target.value})
                        }}
                        />
                      </FloatLabel>

                    </Form.Item>
                    <Space style={{marginTop: 20}} size={[18, 20]} direction="vertical" className="container full ta-center">
                      <Button
                        htmlType="submit"
                        type="primary"
                        className="btn btn-primary">Obnovit heslo</Button>
                    </Space>
                  </Form>
                }
            </Col>
          </Row>
        </section>
      </>
    )
  }
}